import { useDispatch } from 'react-redux'
import { useSetBackChannelLogoutUriMutation } from '../../redux/slices/sessionsSlice'
import { showSuccessNotification, showErrorNotification } from '../../redux/actions'

export default function useClientBackChannelLogout() {
  const dispatch = useDispatch()
  const [setUri, { isLoading }] = useSetBackChannelLogoutUriMutation()

  const save = async (clientId, backChannelLogoutUri) => {
    try {
      await setUri({ clientId, backChannelLogoutUri }).unwrap()
      dispatch(showSuccessNotification('Back-channel logout URL saved.'))
    } catch (error) {
      dispatch(showErrorNotification('Failed to save the back-channel logout URL.'))
      throw error
    }
  }

  return { save, isSaving: isLoading }
}
